import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=4453f35a&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=ts"
export * from "./videoDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./videoDialog.vue?vue&type=style&index=0&id=4453f35a&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4453f35a",
  "d8d7b12e"
  
)

export default component.exports